export default __webpack_public_path__ + "static/4-30b4875f0c0a9c80f2b971155493f954.jpeg";